import React from 'react';
import ErrorBoundary from './ErrorBoundaryComponent';

const applyErrorBoundary = Component => {
  const ProtectedRoute = props => {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
  return ProtectedRoute;
};

export { applyErrorBoundary };
